module.exports = __webpack_public_path__ + "img/money.f38900b1.png";